export default __webpack_public_path__ + "static/media/information--safety-zone--g1.8bc0bf83.png";